export const Integrations = {
  VoucherUnico: 'Voucher Unico',
  PortalTuris: 'Voucher Turis',
  Twilio: 'Twilio SMS',
  Limber: 'Limber'
}
